export const screenWidth = () => {
  const windowWidth = window.innerWidth;

  if (windowWidth > 1279) {
    return "xl";
  }

  if (windowWidth > 1023) {
    return "lg";
  }

  if (windowWidth > 767) {
    return "md";
  }

  if (windowWidth > 639) {
    return "sm";
  }
  return "xs";
};
